import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';
import {Config, HttpMethod} from '@mitel/cloudlink-sdk';


@Injectable({
    providedIn: 'root',
})
/*
Director microservice is not avaiable through the j-sdk, so we
call it directly using same method used in other cloudlink web apps
for calling micros directly.
*/
export class DirectorService {
    public apiDirector: any;
    constructor() {
        this.apiDirector = {
            rootUrl: environment.directorUrl,
            _http: <HttpMethod>  Config.httpService,
            async getIdentitiesDirectly(id: string, idType: string): Promise<any>{
                let url = `${this.rootUrl}/identities?id=${id}&idType=${idType}&$expand`;
                return await this._http.get({url})
                .then(response => response.body)
                .then((data: any) => {
                    if (data._embedded && data._embedded.items && data.count) {
                        return {
                            identities: [...data._embedded.items],
                            count: data.count
                        };
                    } else{
                        return {
                            identities: [],
                            count: 0
                        }
                    }
                });
            }
        }
    }

    public getIdentities(id: string, idType: string): Promise<any>{
        return this.apiDirector.getIdentitiesDirectly(id, idType);
    }
}